import Http, { AUTH_TOKEN_KEY } from '@/Http';
import { USER_REQUEST } from '@/store/models/user';

export const AUTH_REQUEST = 'AUTH_REQUEST';
export const SIGN_UP_REQUEST = 'SIGN_UP_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

const state = {
  token: localStorage.getItem(AUTH_TOKEN_KEY) || '',
  status: '',
  hasLoadedOnce: false
};

const getters = {
  isAuthenticated: (state:any) => !!state.token,
  authStatus: (state:any) => state.status
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch } :any, user:object) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      (new Http()).post({ url: 'login', data: user })
        .then(resp => {
          localStorage.setItem(AUTH_TOKEN_KEY, resp.data.data.access_token);
          commit(AUTH_SUCCESS, resp.data.data.access_token);
          dispatch('user/' + USER_REQUEST);
          resolve(resp);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem(AUTH_TOKEN_KEY);
          reject(err);
        }).catch(() => {
        });
    });
  },
  [SIGN_UP_REQUEST]: ({ commit, dispatch } :any, user:object) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      (new Http()).post({ url: 'register', data: user })
        .then(resp => {
          localStorage.setItem(AUTH_TOKEN_KEY, resp.data.data.access_token);
          commit(AUTH_SUCCESS, resp);
          dispatch('user/' + USER_REQUEST);
          resolve(resp);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem(AUTH_TOKEN_KEY);
          reject(err);
        }).catch(() => {
        });
    });
  },
  [AUTH_LOGOUT]: ({ commit } :any) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT);
      (new Http()).request({ url: 'user/logout', method: 'POST' }).then().catch();
      localStorage.removeItem(AUTH_TOKEN_KEY);
      resolve();
    });
  }
};

const mutations = {
  [AUTH_REQUEST]: (state:any) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state:any, resp:string) => {
    state.status = 'success';
    state.token = resp;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state:any) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state:any) => {
    state.token = '';
    state.hasLoadedOnce = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
